export class BannerSearchRequest {
  query: string;

  constructor(raw?: any) {
    if (raw) {
      Object.assign(this, raw);
    }
  }
}
